import { api } from "@/lib/api";

export interface UserCustomization {
  header_image_url: string | null;
  default_topics: string[] | null;
  default_company: string | null;
}


export async function getUserCustomization(): Promise<UserCustomization> {
  try {
    const response = await api.get<UserCustomization>("/customization");

    const data = response.data;
    if (typeof data.default_topics === 'string') {
      try {
        data.default_topics = JSON.parse(data.default_topics);
      } catch {
        data.default_topics = null;
      }
    }
    return data;
  } catch (error) {
    console.error("Erro ao buscar personalização:", error);

    return { header_image_url: null, default_topics: null, default_company: null };
  }
}


export async function updateUserCustomization(
  headerImageUrl: string | null,
  defaultTopics: string[] | null = null,
  defaultCompany: string | null | undefined = undefined
): Promise<UserCustomization> {
  const payload: any = { header_image_url: headerImageUrl };

  if (defaultTopics !== null) {
    payload.default_topics = JSON.stringify(defaultTopics);
  }

  if (defaultCompany !== undefined) {
    payload.default_company = defaultCompany;
  }

  const response = await api.put<{
    message: string;
    header_image_url: string | null;
    default_topics: string | null;
    default_company: string | null;
  }>(
    "/customization",
    payload
  );

  let parsedTopics = null;
  if (response.data.default_topics) {
    try {
      parsedTopics = JSON.parse(response.data.default_topics);
    } catch {
      parsedTopics = null;
    }
  }

  return {
    header_image_url: response.data.header_image_url,
    default_topics: parsedTopics,
    default_company: response.data.default_company || null
  };
}


export async function deleteUserCustomization(): Promise<void> {
  await api.delete("/customization");
}


export async function uploadCustomizationLogo(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("imagem", file);
  const response = await api.post<{ url: string }>("/customization/logo", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.url;
}


export async function deleteCustomizationLogo(): Promise<void> {
  await api.delete("/customization/logo");
}
